import type { ScatterData } from "plotly.js";
import { FC } from "react";
import { KTM, PlotEl } from "./GraphTypes";
import { LegendMeta, legendText } from "./graphLegendText";

/** Read-only legend (color swatch + name) for places where the interactive table does not fit. */
export const GraphLegend: FC<{ data: Partial<ScatterData>[]; plotlyRef?: PlotEl; }> = ({ data, plotlyRef }) => {
  const seen = new Set<string>();
  const entries = data.flatMap((pd, i) => {
    if (pd.name === KTM.ITEM_TOTAL || pd.visible === false) return [];
    // color may be assigned by plotly only, so fall back to the rendered trace
    const color = (pd.line?.color ?? plotlyRef?._fullData?.[i]?.line?.color) as string;
    const { name, detail } = legendText(pd.meta as LegendMeta | undefined, pd.name);
    const key = [name, detail, color].join('|');
    if (!name || seen.has(key)) return [];
    seen.add(key);
    return [{ key, name, detail, color }];
  });
  if (!entries.length) return null;

  return <div className="xm-graph-legend">
    {entries.map(e => <span key={e.key} className="xm-graph-legend__item" title={e.detail ? `${e.name} ${e.detail}` : e.name}>
      <span className="xm-graph-legend__swatch" style={{ backgroundColor: e.color }} />
      {e.name}
      {e.detail && <span className="xm-graph-legend__metric">{e.detail}</span>}
    </span>)}
  </div>;
};
